import ApiExtension from './api-extension'

export default class Field extends ApiExtension {
  updateField(fieldId, metaData, fieldName) {
    return this.fetch(
      'field',
      { id: fieldId },
      {
        method: 'PUT',
        body: JSON.stringify({
          field: { name: fieldName, metadata: metaData },
        }),
      }
    )
  }
}
